import type { BlockState } from '../types/BlockState';

export const BLOCK_STATE = {
  WAITING: 'waiting',
  FALLING: 'falling',
  RESTING: 'resting',
} as const satisfies Record<string, BlockState>;
